module.exports = __webpack_public_path__ + "static/media/notice.4f8d5aa8.svg";